import { Component, OnInit } from '@angular/core';
import { PartitionsSunburstBase } from '../partitions-sunburst-base/partitions-sunburst-base';

@Component({
    selector: 'app-partitions-sunburst-card',
    templateUrl: './partitions-sunburst-card.component.html',
    styleUrls: ['./partitions-sunburst-card.component.scss']
})
export class PartitionsSunburstCardComponent extends PartitionsSunburstBase implements OnInit {

    constructor() {
        super();
    }

    ngOnInit() {
    }

}
